import start from './start';
import introduction from './introduction';
import become from './become';
import forms from './forms';
import thanks from './thanks';

export default [start, introduction, become, forms, thanks];



// WEBPACK FOOTER //
// ./src/scripts/modules/steps/index.js